import { ChevronRight } from '@ixigo/icons';
import Typography from '@ixigo/iui/Typography';
import clsx from 'clsx';
import { FC } from 'react';
import { Event } from '../../enums/event';
import { recordEvent } from '../../utils/analytics';
import ActiveChatInfo from './ActiveChatInfo';
import BookingInfo from './BookingInfo';
import InactiveChatInfo from './InactiveChatInfo';
import { ChatCardProps } from './index.types';

const ChatCard: FC<ChatCardProps> = ({ className, data }) => {
    const {
        active,
        actorAvatarUrl,
        actorName,
        bookingDetail,
        bookingId,
        createdAt,
        lastMessage,
        title,
        updatedAt,
        url,
    } = data;

    return (
        <div
            className={clsx('flex flex-col gap-15 w-full px-10 py-15 rounded-20 shadow-100 cursor-pointer', className)}
            onClick={() => {
                recordEvent(Event.HC_PAST_CHAT_THREAD_OPEN, {
                    bookingParams: bookingDetail,
                });
                window.location.href = `${window.location.origin}${url}`;
            }}
        >
            <div className='flex flex-col gap-10'>
                <BookingInfo data={bookingDetail} />
                <div className='flex flex-col gap-0.5'>
                    {bookingId && (
                        <Typography variant='body-xs' className='mt-5 text-charcoal-600'>
                            Booking ID: {bookingId}
                        </Typography>
                    )}
                    <div className='flex justify-between items-center gap-10'>
                        <Typography variant='body-md' fontWeight='medium'>
                            {title}
                        </Typography>
                        {!active && <ChevronRight className='shrink-0' />}
                    </div>
                </div>
            </div>
            <div className='w-full h-px bg-charcoal-80' />
            {active ? (
                <ActiveChatInfo actorAvatarUrl={actorAvatarUrl} actorName={actorName} lastMessage={lastMessage} />
            ) : (
                <InactiveChatInfo createdAt={createdAt} updatedAt={updatedAt} />
            )}
        </div>
    );
};

export default ChatCard;
